import React from 'react';
import { Button, Tooltip } from '@mui/material';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { track, EVENTS } from '../../lib/analytics';

interface ManualLinkButtonProps {
  slug: string;
  label?: string;
  /** Id da seção (slug do heading, ver manual/slug.ts): abre o manual já rolado até ela. */
  section?: string;
  /** Link de texto pequeno, para caber dentro de um card (sem borda nem ícone grande). */
  compact?: boolean;
}

const ManualLinkButton: React.FC<ManualLinkButtonProps> = ({
  slug,
  label = 'Manual',
  section,
  compact = false,
}) => {
  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    track(EVENTS.MANUAL_LINK_CLICKED, section ? { slug, section } : { slug });
    const sectionParam = section ? `&section=${encodeURIComponent(section)}` : '';
    window.open(`/?manual=${slug}${sectionParam}`, '_blank');
  };

  if (compact) {
    return (
      <Tooltip title="Abrir manual em nova aba" arrow>
        <Button
          onClick={handleClick}
          variant="text"
          size="small"
          startIcon={<MenuBookIcon sx={{ fontSize: '14px !important' }} />}
          sx={{
            textTransform: 'none',
            fontSize: 12,
            fontWeight: 600,
            color: '#7869DF',
            minWidth: 0,
            whiteSpace: 'nowrap',
            flexShrink: 0,
            px: 0.75,
            py: 0.25,
            '&:hover': { bgcolor: 'rgba(120,105,223,0.06)' },
          }}
        >
          {label}
        </Button>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Abrir manual em nova aba" arrow>
      <Button
        startIcon={<MenuBookIcon />}
        onClick={handleClick}
        variant="outlined"
        size="small"
        sx={{
          textTransform: 'none',
          color: '#7869DF',
          borderColor: '#7869DF',
          '&:hover': {
            borderColor: '#5d50c7',
            bgcolor: 'rgba(120,105,223,0.04)',
          },
        }}
      >
        {label}
      </Button>
    </Tooltip>
  );
};

export default ManualLinkButton;
